import { FC } from "react";
import { ButtonColor } from "@/components/catalyst/button";
import { MultiActionGroupButton } from "@/lib/Components/Actions/Components/MultiActionGroupButton";

export type ActionsHook<T> = (model: T) => ActionGroupButton[];

export interface ActionGroupProps {
  buttons: ActionGroupButton[];
}

export type ActionGroupButtonType = "primary" | "outlined" | "danger";

export type MultiActionGroupButtonType = {
  label: string;
  buttonType?: ActionGroupButtonType;
  items: ActionItemGroup[];
};

export type ActionGroupButton = MultiActionGroupButtonType;

export interface ActionItemGroup {
  actions: Action[];
}

export interface Action {
  color?: ButtonColor;
  label: string;
  Icon?: FC<any>;
  handleAction: () => Promise<any> | void;
  isHidden?: boolean;
  isAdminAction?: boolean;
  isHiddenTopBar?: boolean;
}

export function ActionGroupButtons({ buttons }: ActionGroupProps) {
  return (
    <div className="flex space-x-4">
      {buttons.map((item, index) => {
        return <MultiActionGroupButton key={index} {...item} />;
      })}
    </div>
  );
}
